import { useSuspenseInfiniteQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'

type UserSearchParams = {
  skip?: number
  limit?: number
  query?: string
  profession?: string
  longitude?: number
  latitude?: number
  distance?: number
  expertise?: string[]
  clientType?: string
}

const getUsersBySearch = (params: UserSearchParams) => getRequest<PublicUserData[]>('/users/search', params)

export const useUsersBySearch = (
  limit?: number,
  query?: string,
  profession?: string,
  longitude?: number,
  latitude?: number,
  distance?: number,
  expertise?: string[],
  clientType?: string,
) => {
  const pageSize = limit || 6

  return useSuspenseInfiniteQuery({
    ...queries.users.search(query, profession, longitude, latitude, distance, expertise, clientType),
    queryFn: async ({ pageParam = 0 }) => {
      const response = await getUsersBySearch({
        skip: pageParam,
        limit: pageSize,
        query,
        profession,
        longitude,
        latitude,
        distance,
        expertise,
        clientType,
      })
      return {
        results: response || [],
      }
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, pages) => {
      if (lastPage && lastPage.results.length === pageSize) {
        return pages.length * pageSize
      }
      return undefined
    },
    select: (data) => ({
      pages: data.pages,
      pageParams: data.pageParams,
    }),
    retry: false,
    staleTime: 5 * 60 * 1000,
  })
}
